import { Stack } from '@src/shared/ui/layout';
import Typography from '@src/shared/ui/Typography';
import { useTranslation } from 'react-i18next';

const StyleSheet = {
  header: {
    justifyContent: 'space-between',
    marginBottom: '18px',
  },
};

export default function TasksHeader() {
  const { t } = useTranslation();
  return (
    <Stack direction="row" sx={StyleSheet.header}>
      <Typography variant="h5">{t('common.tasks', 'Tasks')}</Typography>
    </Stack>
  );
}
